export default "__VITE_ASSET__C6p5syM1__"